<p-button
  (onClick)="onClick.emit($event)"
  [autofocus]="autofocus()"
  [ariaLabel]="ariaLabel()"
  [badgeSeverity]="badgeSeverity()"
  [badge]="badge()"
  [disabled]="disabled()"
  [iconPos]="iconPos()"
  [icon]="icon()"
  [label]="label()"
  [link]="link()"
  [loading]="loading()"
  [class.button-highlighted]="isHighlighted()"
  [class.tw:w-full]="fluid()"
  [outlined]="outlined()"
  [pAutoFocus]="pAutoFocus()"
  [pt]="{
    root: {
      'aria-current': ariaCurrent(),
      'aria-pressed': ariaPressed(),
    },
  }"
  [rounded]="rounded()"
  [severity]="severity()"
  [size]="size()"
  [styleClass]="`${styleClass() ?? ''}${fluid() ? ' tw:w-full' : ''}`"
  [style]="style()"
  [tabindex]="undefined"
  [text]="text()"
  [type]="type()"
  [variant]="variant()"
  pRipple
>
  @if (iconTemplate()) {
    <ng-template #icon>
      <ng-container *ngTemplateOutlet="iconTemplate()" />
    </ng-template>
  }
  @if (contentTemplate()) {
    <ng-template #content>
      <ng-container *ngTemplateOutlet="contentTemplate()" />
    </ng-template>
  }
</p-button>
